import { render, staticRenderFns } from "./RecommendationsFormSteps.vue?vue&type=template&id=403149a2"
import script from "./RecommendationsFormSteps.vue?vue&type=script&lang=js"
export * from "./RecommendationsFormSteps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports